import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPreguntasConfirmacionThunk } from "../store/reducers/preguntasConfirmacion/preguntasConfirmacion.thunks";
import PreguntasConfirmacionHeader from "../components/preguntasConfirmacion/PreguntasConfirmacionHeader";
import PreguntasConfirmacionTable from "../components/preguntasConfirmacion/PreguntasConfirmacionTable";
import PreguntaConfirmacionViewModal from "../components/preguntasConfirmacion/PreguntaConfirmacionViewModal";
import ConfirmToggleModal from "../components/preguntasConfirmacion/ConfirmToggleModal";
import PreguntaConfirmacionFormModal from "../components/preguntasConfirmacion/PreguntaConfirmacionFormModal";
import Loader from "../components/UI/Loader";
import Alert from "../components/UI/Alert";
import Pagination from "../components/UI/Pagination";
import {
  clearPreguntasConfirmacionError,
  setPage,
} from "../store/reducers/preguntasConfirmacion/preguntasConfirmacion.reducer";
import EmptyState from "./UI/EmptyState";
import { Icon } from "@iconify/react";

const PreguntasConfirmacionListLayer = () => {
  const dispatch = useDispatch();
  const { list, loading, error, page, pageSize, search, count } = useSelector(
    (state) => state.preguntasConfirmacion
  );

  useEffect(() => {
    dispatch(getPreguntasConfirmacionThunk({ page, search }));
  }, [dispatch, page, search]);

  const handlePageChange = (newPage) => {
    dispatch(setPage(newPage));
  };

  return (
    <div className="card p-0 radius-12">
      <div className="card-body p-24">
        <PreguntasConfirmacionHeader />

        {/* ERROR */}
        {error && (
          <Alert
            message={error}
            variant="error"
            onClose={() => dispatch(clearPreguntasConfirmacionError())}
          />
        )}

        {/* LOADING */}
        {loading ? (
          <Loader center text="Cargando preguntas..." delay={200} />
        ) : (
          <>
            {/* INFO DE BÚSQUEDA */}
            {search && (
              <div className="mb-3 d-flex align-items-center gap-2 text-secondary-light">
                <Icon icon="mdi:information-outline" width="18" />
                <span className="text-sm">
                  {count > 0 ? (
                    <>
                      Se {count === 1 ? "encontró" : "encontraron"}{" "}
                      <strong className="text-primary">{count}</strong>{" "}
                      {count === 1 ? "resultado" : "resultados"} para "{search}"
                    </>
                  ) : (
                    <>No se encontraron resultados para "{search}"</>
                  )}
                </span>
              </div>
            )}

            {/* EMPTY / TABLE */}
            {list.length === 0 ? (
              <EmptyState
                icon={
                  search
                    ? "mdi:magnify-remove-outline"
                    : "mdi:help-circle-outline"
                }
                title={
                  search
                    ? "No se encontraron preguntas"
                    : "No hay preguntas registradas"
                }
                description={
                  search
                    ? "Intenta con otra búsqueda"
                    : "No hay preguntas disponibles"
                }
              />
            ) : (
              <>
                <PreguntasConfirmacionTable preguntas={list} search={search} />

                <Pagination
                  page={page}
                  count={count}
                  pageSize={pageSize}
                  onPageChange={handlePageChange}
                />
              </>
            )}
          </>
        )}
      </div>

      {/* MODALES */}
      <PreguntaConfirmacionViewModal />
      <PreguntaConfirmacionFormModal />
      <ConfirmToggleModal />
    </div>
  );
};

export default PreguntasConfirmacionListLayer;
